import styled from "styled-components";

const ModalContainerSC = styled("div")`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  animation: modalin 0.7s ease-in-out;
  @keyframes modalin {
    from {
      transform: translate(150%, -50%);
    }
    to {
      transform: translate(-50%, -50%);
    }
  }
`;

const MainContainerSC = styled.div`
  z-index: 5;
  position: relative;
  width: 50%;
  max-width: 48rem;
  height: 41rem;
  background: rgba(0, 0, 0, 0.7);
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  padding: 1.16rem;

  display: flex;
  flex-direction: column;
  gap: 1.16rem;

  @media (max-width: 1174px) {
    width: 90%;
    max-width: none;
  }
`;

const ContainerSC = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
  }

  /* Цвет скролла */

  &::-webkit-scrollbar-thumb {
    background-color: #d6d9e3;
  }

  /* Скрытие канавки скролла */

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

const TitleSC = styled.p`
  color: white;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
`;

const ModalBackdoorSC = styled("div")`
  position: fixed;
  z-index: 0;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  animation: modalBackdoorIn 0.7s ease-in-out;
  @keyframes modalBackdoorIn {
    from {
      background-color: rgba(0, 0, 0, 0);
    }
    to {
      background-color: rgba(0, 0, 0, 0.4);
    }
  }
`;

const DeleteButtonSC = styled.p`
  cursor: pointer;
  color: lightgray;
  font-size: 1rem;
  font-weight: 400;
  line-height: normal;
`;

const ReplyIconSC = styled.img`
  cursor: pointer;
  width: 30px;
  height: 30px;
`;

const BasketListSC = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-right: 16px;
`;

const TopContainer = styled.div`
  display: inline-flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`;

const PlaceholderSC = styled.h3`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
`;

const TotalSC = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.16rem;

  div {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    color: white;
  }
`;

export const useBasketStyles = () => ({
  ContainerSC,
  ModalBackdoorSC,
  ModalContainerSC,
  ReplyIconSC,
  DeleteButtonSC,
  TitleSC,
  BasketListSC,
  TopContainer,
  PlaceholderSC,
  MainContainerSC,
  TotalSC,
});
